import {defineStore} from 'pinia'
import {http} from '@/extensions/http'
import API_ENDPOINTS from '@/config/API_ENDPOINTS.ts'
import i18n from '@/i18n'

export const useEventStore = defineStore('event', {
    state: () => ({
        memory: {
            index: {
                en: [],
                fr: []
            } as Record<locale, Event[]>,
            show: {
                en: {},
                fr: {}
            } as Record<locale, Record<string, Event | undefined>>
        }
    }),
    actions: {
        async all() {
            const locale: locale = i18n.global.locale.value

            if (this.memory.index[locale].length) return this.memory.index[locale]

            const {data} = await http.get<Event[]>(API_ENDPOINTS.EVENT.INDEX.replace(':chair', import.meta.env.VITE_APP_CHAIR_ID))

            this.memory.index[locale] = data

            return data
        },
        async get(eventId: string | number) {
            const locale: locale = i18n.global.locale.value

            if (this.memory.show[locale][eventId] !== undefined) {
                return this.memory.show[locale][eventId]
            }

            const {data} = await http.get<Event>(API_ENDPOINTS.EVENT.SHOW.replace(':chair', import.meta.env.VITE_APP_CHAIR_ID).replace(':event', eventId.toString()))

            this.memory.show[locale][eventId] = data

            return data
        }
    }
})